import { render, staticRenderFns } from "./SearchAiPage.vue?vue&type=template&id=8b88b8ae"
import script from "./SearchAiPage.vue?vue&type=script&lang=js"
export * from "./SearchAiPage.vue?vue&type=script&lang=js"
import style0 from "./SearchAiPage.vue?vue&type=style&index=0&id=8b88b8ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports